module.exports = __webpack_public_path__ + "img/inquiry_icon.96f96e01.png";